"use client";

import { formatNumberWithDecimalPlaces } from "@/Utils/formatFunctions";
import { EmptyView } from "@/components/EmptyView/EmptyView";

import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export type SortingRateOverTimeData = {
  name: string;
  value: number;
  sortingRate: number;
  percentLabel: string;
  clientSortingRate?: number;
  buildingSortingRate?: number;
};
export default function AreaChartGraph({
  data,
  color,
  dataKey,
}: {
  data: any[];
  color: string;
  dataKey: string;
}) {
  if (!data.find((d) => d[dataKey])) {
    return (
      <div className="flex h-full w-full flex-col justify-stretch">
        <EmptyView type="noDataForInterval" className="h-full" />
      </div>
    );
  }

  return (
    <div className="h-full w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{
            top: 20,
            right: 20,
            left: -20,
            bottom: 0,
          }}
          onContextMenu={(_, e) => e.preventDefault()}
        >
          <CartesianGrid stroke="#DAD3D3" vertical={false} />
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11 }}
          />
          <YAxis
            type="number"
            unit={"%"}
            ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
            tick={{ fontSize: 11 }}
          />
          <Tooltip
            cursor={{ fill: "#88888844" }}
            formatter={(value) =>
              `${formatNumberWithDecimalPlaces(Number(value ?? 0), 2)}%`
            }
            itemStyle={{ color: "black" }}
            labelStyle={{ fontWeight: "bold" }}
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke="black"
            fill={color}
            isAnimationActive={false}
            dot={true}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
